// src/socket.js
import { io } from "socket.io-client";

const getSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) return process.env.REACT_APP_SOCKET_URL;
  if (typeof window !== "undefined") return window.location.origin;
  return "http://localhost:3002";
};

// En producción usa el mismo origen del CMS; en local puede sobreescribirse con REACT_APP_SOCKET_URL.
const socket = io(getSocketUrl(), {
  path: "/socket.io",
  autoConnect: false,
  auth: (callback) => {
    callback({ token: localStorage.getItem("auth_token") });
  },
});

export default socket;
